import { OrangeButton } from "../../utils/buttons";
import "./MobileNavbar.css";
import { useState } from "react";
import { Link } from "react-router-dom";

const aboutUs = [
  {
    title: "Company Profile",
    link: "/about-us",
  },
  {
    title: "Awards & Recognition",
    link: "/about-us/awards-and-recognition",
  },
  {
    title: "Blog",
    wlink: "https://blog.orionedutech.com",
  }
];
const ourPrograms = [
  {
    title: "Staffing - Corporate Alliance",
    /* wlink: "https://staffing.orionedutech.in/", */ 
    wlink: "https://www.orioncorporate.com/", 
  },
  {
    title: "Content Development",
    /* link: "/content-development", */ 
    wlink: "https://www.orionsoftechcontentgrill.com/",
  },
  /*{
    title: "International Businesses",
    link: "/international-business",
  },*/
  {
    title: "Skill Development",
    link: "/skill-development",
  },
  {
    title: "Corporate Sponsored Skilling",
    link: "/corporate-social-responsibility",
  },
  {
    title: "Certification Programs", 
    wlink: "https://iift.orionedutech.com",
  },
  /*
  {
    submenutitle: "Foreign Internship",
    // link: "/foreign-internship", 
    link: "", 
    submenuitems: [
      {
        title: "TITP",
        wlink: "https://foreign-internship.orionedutech.com",
      },
      {
        title: "SSW",
        wlink: "https://skilled-worker.orionedutech.com/",
      },
    ],
  },
  */

  /*
  {
    title: "International Schooling",
    wlink: "https://international-schooling.orionedutech.com",
  },
  */
  /*{
    // Indranil: 09Dec24: Changed name from "Nursing Jobs Abroad" to "International Recruitment"
    submenutitle: "Nursing Jobs Abroadt",
    link: "",
    submenuitems: [
      {
        title: "Germany",
        wlink: "https://germannursing.orionedutech.in/",
      },
    ],
  },*/
  /*
  {
    title: "Specified Skilled Worker (SSW)",
    wlink: "https://skilled-worker.orionedutech.com/",
  },
  */
  //{
    //submenutitle: "University Programs",
    //link: "",
    //submenuitems: [
      /*
      {
        title: "IGNOU",
        wlink: "/ignou",
      },
      */
      /*{
        title: "Manav Rachna",
        wlink: "https://manav-rachna.orionedutech.com",
      },*/
      /*
      {
        title: "Rayat Bahra",
        wlink: "https://rayat-bahra.orionedutech.com",
      }, 
      */
    //],
  //},
];

/*
const ourServices = [
  {
    title: "Staffing - Corporate Alliance",
    wlink: "https://staffing.orionedutech.in/",
  },
  {
    title: "Content Development",
    link: "/content-development",
  },
  {
    title: "International Businesses",
    link: "/international-business",
  },
];
*/ 

const studyAbroad = [
  {
    title: "Study Abroad",
    /*link: "/study-abroad" */
    wlink: "https://study-abroad.orionedutech.com"
  },
  /*{
    // Indranil: 09Dec24: Changed name from "Nursing Jobs Abroad" to "International Recruitment"
    submenutitle: "Nursing Jobs Abroad",
    link: "",
    submenuitems: [
      {
        title: "Germany",
        wlink: "https://germannursing.orionedutech.in/",
      },
    ],
  },*/
];

const centersCourses = [
  {
    title: "Locate Centres / Institutions",
    /*link: "/study-abroad" */
    wlink: "https://centres.orionedutech.com"
  }
];

const orionVersity = [
  {
    title: "OrionVersity",
    /*link: "/study-abroad" */
    wlink: "https://orionversity.com"
  }
];

export const MobileNavbar = ({ mobileMenuActive, handleMobileMenuActive }) => {
  const [aboutUsSubMenuDisplay, setAboutUsSubMenuDisplay] = useState(false);
  const [ourProgramsSubMenuDisplay, setOurProgramsSubMenuDisplay] =
    useState(false);
  const [ourServicesSubMenuDisplay, setOurServicesSubMenuDisplay] =
    useState(false);
  const [univProgramsSubMenuDisplay, setUnivProgramsSubMenuDisplay] =
    useState(false);
  const [studyAbroadSubMenuDisplay, setStudyAbroadSubMenuDisplay] =
    useState(false);
  const [nursingSubMenuDisplay, setNursingSubMenuDisplay] =
    useState(false);
  const [finternSubMenuDisplay, setFinternSubMenuDisplay] =
    useState(false);
  const [centersCoursesSubMenuDisplay, setCentersCoursesSubMenuDisplay] =
    useState(false); 
  const [orionVersitySubMenuDisplay, setOrionVersitySubMenuDisplay] =
    useState(false);  

  const handleChangeAboutUs = () => {
    setAboutUsSubMenuDisplay(!aboutUsSubMenuDisplay);
    setOurProgramsSubMenuDisplay(false);
    setOurServicesSubMenuDisplay(false);
    setUnivProgramsSubMenuDisplay(false);
    setStudyAbroadSubMenuDisplay(false);
    setCentersCoursesSubMenuDisplay(false);
    setOrionVersitySubMenuDisplay(false);
  };
  const handleChangeOurServices = () => {
    setOurServicesSubMenuDisplay(!ourServicesSubMenuDisplay);
    setAboutUsSubMenuDisplay(false);
    setOurProgramsSubMenuDisplay(false);
    setUnivProgramsSubMenuDisplay(false);
    setStudyAbroadSubMenuDisplay(false);
    setCentersCoursesSubMenuDisplay(false);
    setOrionVersitySubMenuDisplay(false);
  };
  const handleChangeOurPrograms = () => {
    setOurProgramsSubMenuDisplay(!ourProgramsSubMenuDisplay);
    setAboutUsSubMenuDisplay(false);
    setOurServicesSubMenuDisplay(false);
    setStudyAbroadSubMenuDisplay(false);
    setCentersCoursesSubMenuDisplay(false);
    setOrionVersitySubMenuDisplay(false);
  };
  const handleChangeStudyAbroad = () => {
    setStudyAbroadSubMenuDisplay(!studyAbroadSubMenuDisplay);
    setOurProgramsSubMenuDisplay(false);
    setAboutUsSubMenuDisplay(false);
    setOurServicesSubMenuDisplay(false);
    setCentersCoursesSubMenuDisplay(false);
    setOrionVersitySubMenuDisplay(false);
  };
  const handleChangeOrionVersity = () => {
    setOrionVersitySubMenuDisplay(!orionVersitySubMenuDisplay);
    setOurProgramsSubMenuDisplay(false);
    setAboutUsSubMenuDisplay(false);
    setOurServicesSubMenuDisplay(false);
    setStudyAbroadSubMenuDisplay(false);
    setCentersCoursesSubMenuDisplay(false);
  };
  const handleChangeCentersCourses = () => {
    setCentersCoursesSubMenuDisplay(!centersCoursesSubMenuDisplay);
    setOurProgramsSubMenuDisplay(false);
    setAboutUsSubMenuDisplay(false);
    setOurServicesSubMenuDisplay(false);
    setStudyAbroadSubMenuDisplay(false);
    setOrionVersitySubMenuDisplay(false);
  };


  const handleChangeUnivPrograms = (event) => {
    setUnivProgramsSubMenuDisplay(!univProgramsSubMenuDisplay);
    event.stopPropagation();
  };
  const handleChangeNursing = (event) => {
    setNursingSubMenuDisplay(!nursingSubMenuDisplay);
    event.stopPropagation();
  };
  const handleChangeFintern = (event) => {
    setFinternSubMenuDisplay(!finternSubMenuDisplay);
    event.stopPropagation();
  };

  const handleReset = () => {
    setAboutUsSubMenuDisplay(false);
    setOurProgramsSubMenuDisplay(false);
    setOurServicesSubMenuDisplay(false);
    setUnivProgramsSubMenuDisplay(false);
    setStudyAbroadSubMenuDisplay(false);
    setCentersCoursesSubMenuDisplay(false);
    setOrionVersitySubMenuDisplay(false);
  };

  return (
    <div className={mobileMenuActive ? "mobile-nav active" : "mobile-nav"}>
      <div className="mobile-nav-items">
        <ul className="mobile-nav-items-list">
          <li onClick={handleMobileMenuActive} className="nav-item-m">
            <Link to="/">Home</Link>
          </li>

          <li
            onClick={handleChangeAboutUs}
            className="nav-item-m nav-item-icon-cont"
          >
            About Us
            {aboutUsSubMenuDisplay ? (
              <i class="fas fa-chevron-up"></i>
            ) : (
              <i class="fas fa-chevron-down"></i>
            )}
          </li>
          <SubMenu
            subMenuDisplay={aboutUsSubMenuDisplay}
            handleReset={handleReset}
            data={aboutUs}
            handleMobileMenuActive={handleMobileMenuActive}
          />

          {/*
          <li
            onClick={handleChangeOurServices}
            className="nav-item-m nav-item-icon-cont"
          >
            Our Services
            {ourServicesSubMenuDisplay ? (
              <i class="fas fa-chevron-up"></i>
            ) : (
              <i class="fas fa-chevron-down"></i>
            )}
          </li>
          <SubMenu
            subMenuDisplay={ourServicesSubMenuDisplay}
            handleReset={handleReset}
            data={ourServices}
            handleMobileMenuActive={handleMobileMenuActive}
          />
          */}

          <li
            onClick={handleChangeOurPrograms}
            className="nav-item-m nav-item-icon-cont"
          >
            Our Services
            {ourProgramsSubMenuDisplay ? (
              <i class="fas fa-chevron-up"></i>
            ) : (
              <i class="fas fa-chevron-down"></i>
            )}
          </li>
          <ProgSubMenu
            subMenuDisplay={ourProgramsSubMenuDisplay}
            handleReset={handleReset}
            data={ourPrograms}
            handleMobileMenuActive={handleMobileMenuActive}
            univsubMenuDisplay={univProgramsSubMenuDisplay}
            univHandleChange={handleChangeUnivPrograms}
            univhandleReset={handleReset}
            nursingsubMenuDisplay={nursingSubMenuDisplay}
            nursingHandleChange={handleChangeNursing}
            nursinghandleReset={handleReset}
            finternsubMenuDisplay={finternSubMenuDisplay}
            finternHandleChange={handleChangeFintern}
            finternhandleReset={handleReset}
        />

          <li
            onClick={handleChangeStudyAbroad}
            className="nav-item-m nav-item-icon-cont"
          >
            Study Abroad
            {studyAbroadSubMenuDisplay ? (
              <i class="fas fa-chevron-up"></i>
            ) : (
              <i class="fas fa-chevron-down"></i>
            )}
          </li>
          <StudyAbroadSubMenu
            subMenuDisplay={studyAbroadSubMenuDisplay}
            handleReset={handleReset}
            data={studyAbroad}
            handleMobileMenuActive={handleMobileMenuActive}
            nursingsubMenuDisplay={nursingSubMenuDisplay}
            nursingHandleChange={handleChangeNursing}
            nursinghandleReset={handleReset}
          />

          {/*}
          <li
            onClick={handleChangeOrionVersity}
            className="nav-item-m nav-item-icon-cont"
          >
            OrionVersity
            {orionVersitySubMenuDisplay ? (
              <i class="fas fa-chevron-up"></i>
            ) : (
              <i class="fas fa-chevron-down"></i>
            )}
          </li>
          <SubMenu
            subMenuDisplay={orionVersitySubMenuDisplay}
            handleReset={handleReset}
            data={orionVersity}
            handleMobileMenuActive={handleMobileMenuActive}
          />
          */}

          <li
            onClick={handleChangeCentersCourses}
            className="nav-item-m nav-item-icon-cont"
          >
            Centers
            {centersCoursesSubMenuDisplay ? (
              <i class="fas fa-chevron-up"></i>
            ) : (
              <i class="fas fa-chevron-down"></i>
            )}
          </li>
          <SubMenu
            subMenuDisplay={centersCoursesSubMenuDisplay}
            handleReset={handleReset}
            data={centersCourses}
            handleMobileMenuActive={handleMobileMenuActive}
          />


          {/*}
          <li onClick={handleMobileMenuActive} className="nav-item tab-hide">
            <Link to="/corporate-social-responsibility">CSR</Link>
          </li>
          */}
          
          { /* <li onClick={handleMobileMenuActive} className="nav-item-m">
            <Link to="/contact-us">Contact Us</Link>
            </li> */ }
          <li className="nav-item tab-hide">
            <a href="https://contact.orionedutech.com">Contact Us</a> 
          </li>

          {/*
          <a
            className="nav-item-m"
            target="_blank"
            rel="noreferrer"
            href="https://play.google.com/store/apps/details?id=com.learnhath.OrionEdutech"
          >
            <OrangeButton text="Download App" login />
          </a>
          */}

          {/*
          <a
            className="nav-item-m"

            // target="_blank"
            rel="noreferrer"
            href="https://pay.orionedutech.com/"
          >
            <OrangeButton text="Pay Now" login />
          </a>
          */}

          {/*
          <a
            className="nav-item-m"

            // target="_blank"
            rel="noreferrer"
            href="https://orionedutechfiles.s3.ap-south-1.amazonaws.com/fms/uploadImage/OrionEdutech_Sharod_Samman.docx"
          >
            <OrangeButton text="Sharod Samman" login />
          </a>
          */} 
          
        </ul>
      </div>
    </div>
  );
};

const SubMenu = ({
  subMenuDisplay,
  handleReset,
  left,
  data,
  handleMobileMenuActive,
}) => {
  return (
    <div
      className={`mob-sub-menu ${subMenuDisplay ? "mob-active" : null}`}
      onClick={handleReset}
    >
      {data.map((item) => {
        return item.wlink ? (
          <a
            onClick={handleMobileMenuActive}
            rel="noreferrer"
            href={item.wlink}
            className={item.title=="University Programs" ? "mob-sub-menu-item-bold" : "mob-sub-menu-item"}
          >
            {item.title}
          </a>
        ) : (
          <Link
            onClick={handleMobileMenuActive}
            to={item.link}
            className={item.title=="University Programs" ? "mob-sub-menu-item-bold" : "mob-sub-menu-item"}
          >
            {item.title}
          </Link>
        );
      })}
    </div>
  );
};

const ProgSubMenu = ({
  subMenuDisplay,
  handleReset,
  left,
  data,
  handleMobileMenuActive,
  univsubMenuDisplay, univHandleChange, univhandleReset,
  nursingsubMenuDisplay, nursingHandleChange, nursinghandleReset,
  finternsubMenuDisplay, finternHandleChange, finternhandleReset,
}) => {
  return (
    <div
      className={`mob-sub-menu ${subMenuDisplay ? "mob-active" : null}`}
      onClick={handleReset}
    >
      {data.map((item) => {
        return item.submenutitle=="Foreign Internship" ? (
          <div>
          <li
            onClick={finternHandleChange}
            className={"nav-item-m nav-item-icon-cont"}
          >
          <Link
            onClick={finternsubMenuDisplay}
            to={item.link}
            className={"nested-mob-sub-menu-item"}
          >
            {item.submenutitle}
          </Link>
            {finternsubMenuDisplay ? (
              <i class="fas fa-chevron-up"></i>
            ) : (
              <i class="fas fa-chevron-down"></i>
            )}
          </li>
            <div
            className={`mob-sub-menu ${finternsubMenuDisplay ? "mob-active" : null}`}
            onClick={finternHandleChange}
            >
            {item.submenuitems.map((sitem) => {
                return (
                <a
                onClick={handleMobileMenuActive}
                rel="noreferrer"
                href={sitem.wlink}
                className={"mob-sub-menu-item"}
              >
                {sitem.title}
              </a>
                )
              })}
            </div>
          </div>
        ) :
        // Indranil: 09Dec24: Changed name from "Nursing Jobs Abroad" to "International Recruitment"
        item.submenutitle=="Nursing Jobs Abroad" ? (
          <div>
          <li
            onClick={nursingHandleChange}
            className={"nav-item-m nav-item-icon-cont"}
          >
          <Link
            onClick={nursingsubMenuDisplay}
            to={item.link}
            className={"nested-mob-sub-menu-item"}
          >
            {item.submenutitle}
          </Link>
            {nursingsubMenuDisplay ? (
              <i class="fas fa-chevron-up"></i>
            ) : (
              <i class="fas fa-chevron-down"></i>
            )}
          </li>
            <div
            className={`mob-sub-menu ${nursingsubMenuDisplay ? "mob-active" : null}`}
            onClick={nursingHandleChange}
            >
            {item.submenuitems.map((sitem) => {
                return (
                <a
                onClick={handleMobileMenuActive}
                rel="noreferrer"
                href={sitem.wlink}
                className={"mob-sub-menu-item"}
              >
                {sitem.title}
              </a>
                )
              })}
            </div>
          </div>
        ) :
        
        item.submenutitle=="University Programs" ? (
          <div>
          <li
            onClick={univHandleChange}
            className={"nav-item-m nav-item-icon-cont"}
          >
          <Link
            onClick={univsubMenuDisplay}
            to={item.link}
            className={"nested-mob-sub-menu-item"}
          >
            {item.submenutitle}
          </Link>
            {univsubMenuDisplay ? (
              <i class="fas fa-chevron-up"></i>
            ) : (
              <i class="fas fa-chevron-down"></i>
            )}
          </li>
            <div
            className={`mob-sub-menu ${univsubMenuDisplay ? "mob-active" : null}`}
            onClick={univHandleChange}
            >
            {item.submenuitems.map((sitem) => {
                return (
                <a
                onClick={handleMobileMenuActive}
                rel="noreferrer"
                href={sitem.wlink}
                className={"mob-sub-menu-item"}
              >
                {sitem.title}
              </a>
                )
              })}
            </div>
          </div>
        ) :
        
        item.wlink ? (
          <a
            onClick={handleMobileMenuActive}
            rel="noreferrer"
            href={item.wlink}
            className={"mob-sub-menu-item"}
          >
            {item.title}
          </a>
        ) : (
          <Link
            onClick={handleMobileMenuActive}
            to={item.link}
            className={"mob-sub-menu-item"}
          >
            {item.title}
          </Link>
        );
      })}
    </div>
  );
};

const StudyAbroadSubMenu = ({
  subMenuDisplay,
  handleReset,
  left,
  data,
  handleMobileMenuActive,
  nursingsubMenuDisplay, nursingHandleChange, nursinghandleReset,
}) => {
  return (
    <div
      className={`mob-sub-menu ${subMenuDisplay ? "mob-active" : null}`}
      onClick={handleReset}
    >
      {data.map((item) => {
        return item.submenutitle=="Nursing Jobs Abroad" ? (
          <div>
          <li
            onClick={nursingHandleChange}
            className={"nav-item-m nav-item-icon-cont"}
          >
          <Link
            onClick={nursingsubMenuDisplay}
            to={item.link}
            className={"nested-mob-sub-menu-item"}
          >
            {item.submenutitle}
          </Link>
            {nursingsubMenuDisplay ? (
              <i class="fas fa-chevron-up"></i>
            ) : (
              <i class="fas fa-chevron-down"></i>
            )}
          </li>
            <div
            className={`mob-sub-menu ${nursingsubMenuDisplay ? "mob-active" : null}`}
            onClick={nursingHandleChange}
            >
            {item.submenuitems.map((sitem) => {
                return (
                <a
                onClick={handleMobileMenuActive}
                rel="noreferrer"
                href={sitem.wlink}
                className={"mob-sub-menu-item"}
              >
                {sitem.title}
              </a>
                )
              })}
            </div>
          </div>
        ) :
        
        item.wlink ? (
          <a
            onClick={handleMobileMenuActive}
            rel="noreferrer"
            href={item.wlink}
            className={"mob-sub-menu-item"}
          >
            {item.title}
          </a>
        ) : (
          <Link
            onClick={handleMobileMenuActive}
            to={item.link}
            className={"mob-sub-menu-item"}
          >
            {item.title}
          </Link>
        );
      })}
    </div>
  );
};
